import React from 'react';
import Recaptcha from 'react-grecaptcha';

import { CaptchaWrapper } from './Styles';

interface Props {
  recaptchaSiteKey: string;
  handleCaptcha: (res: string) => void;
  handleCaptchaExpire: () => void;
}

export const Captcha: React.FC<Props> = ({
  recaptchaSiteKey,
  handleCaptcha,
  handleCaptchaExpire,
}) => {
  return (
    <CaptchaWrapper>
      <Recaptcha
        sitekey={recaptchaSiteKey}
        callback={handleCaptcha}
        expiredCallback={handleCaptchaExpire}
      />
    </CaptchaWrapper>
  );
};
